<template>
    <div>
         <v-form ref="signupform" v-model="valid"  @keyup.native.enter="valid" onSubmit="return false;" lazy-validation>
            <span class="logintext">{{labels.finalizeSignupTitle}}</span>
            <span class="logintextsubtitle">{{labels.finalizeSignupSubTitle}} </span>
            <div class="loginform">
                <v-layout row>
                    <v-flex xs5>
                        <v-text-field v-model="userInfos.firstName" :label="labels.firstName" :placeholder="labels.firstNamePlaceholder" @input="isFormValid" :rules="requiredRules" required></v-text-field>
                    </v-flex>
                    <v-flex xs5 offset-xs2 >
                        <v-text-field v-model="userInfos.lastName" :label="labels.lastName" :placeholder="labels.lastNamePlaceholder" @input="isFormValid" :rules="requiredRules" required></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <v-text-field v-model="userInfos.password" :label="labels.password" @input="isCompliant()" @change="isCompliant()"  :placeholder="labels.passwordPlaceholder" required :type = "'password'" ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row  wrap >
                  <v-flex xs12 md6 v-for="(passwordRule, index) in passwordRules" :key="index">
                    <span :class="passwordRule.isValid ?'ovalvalid' : 'oval'"></span>
                    <span :class="passwordRule.isValid ?'signuptextvalid' : ''">  {{$t(passwordRule.key)}} </span>
                    <v-tooltip v-if="passwordRule.tooltipKey" top>
                      <template v-slot:activator="{ on }">
                        <span :class="passwordRule.isValid ?'icon-attention-info-gray-valid' : 'icon-attention-info-gray'" style="font-size:16px; font-weight:bold;" v-on="on"></span>
                      </template>
                      <span>{{$t(passwordRule.tooltipKey)}}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout row  style="margin-top: 25px;">
                    <v-flex xs12>
                        <div class="acceptterms">
                        <span>
                            <v-checkbox v-model="userInfos.acceptTerms" @change="isFormValid" color="primary" label=""> </v-checkbox>
                        </span>
                        <span style="margin-top: 2px;">{{labels.acceptTermsServiceFirst}} <a v-on:click='showAcceptTerms'>{{labels.acceptTermsServiceSecond}}</a></span>
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-btn block type="submit" v-if="!loadingSignUp" :disabled="!canSignup" color="primary" @click="signup">{{labels.btnSignupText}}</v-btn>
                    <div v-if="loadingSignUp" class="text-xs-center" style="width: 100%">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                </v-layout>
            </div>
         </v-form>
    </div>
</template>
<script>
export default {
  props: { passwordRules: Array },
  data () {
    return {
      labels: {
        finalizeSignupTitle: this.$t('Login.SignUp.FINALIZE_SIGNUP_TITLE'),
        finalizeSignupSubTitle: this.$t('Login.SignUp.FINALIZE_SIGNUP_DESC'),
        firstName: this.$t('Login.SignUp.FIRST_NAME_FIELD_NAME') + ' *',
        firstNamePlaceholder: this.$t('Login.SignUp.FIRST_NAME_PLACEHOLDER'),
        lastName: this.$t('Login.SignUp.LAST_NAME_FIELD_NAME') + ' *',
        lastNamePlaceholder: this.$t('Login.SignUp.LAST_NAME_PLACEHOLDER'),
        password: this.$t('Login.SignUp.PASSWORD_FIELD_NAME') + ' *',
        passwordPlaceholder: this.$t('Login.SignUp.PASSWORD_PLACEHOLDER'),
        acceptTermsServiceFirst: this.$t('Login.SignUp.ACCEPT_TERMS_OF_SERVICE_DESC'),
        acceptTermsServiceSecond: this.$t('Login.SignUp.TERMS_OF_SERVICE_LINK'),
        btnSignupText: this.$t('Login.SignUp.SIGN_UP_BTN')
      },
      valid: false,
      userInfos: {
        firstName: '',
        lastName: '',
        password: '',
        acceptTerms: false
      },
      loadingSignUp: false,
      canSignup: false,
      requiredRules: [
        v => !!v || ''
      ]
    }
  },
  methods: {
    signup () {
      if (this.isFormValid()) {
        this.$emit('signup', this.userInfos)
        this.loadingSignUp = true
      }
    },
    isCompliant () {
      this.passwordRules.forEach((passwordRule) => {
        if (passwordRule.regex !== '') {
          passwordRule.isValid = this.validRegex(passwordRule.regex, this.userInfos.password)
        }
      })
      this.isFormValid()
    },
    isAllRegexValid () {
      return !this.passwordRules.some((passwordRule) => !passwordRule.isValid)
    },
    validRegex (regexUsed, text) {
      var regex = RegExp(regexUsed)
      return regex.test(text)
    },
    showAcceptTerms () {
      this.$store.dispatch('global/setAcceptTermsDialog', true)
    },
    isFormValid () {
      this.canSignup = this.$refs.signupform.validate() && this.isAllRegexValid() && this.userInfos.acceptTerms
      return this.canSignup
    },
    signupCompleted () {
      this.loadingSignUp = false
      this.canSignup = false
      this.userInfos = {
        firstName: '',
        lastName: '',
        password: '',
        acceptTerms: false
      }
      this.passwordRules.forEach((passwordRule) => { passwordRule.isValid = false })
    },
    signupFailed () {
      this.loadingSignUp = false
    }
  }
}
</script>
